import { render, staticRenderFns } from "./ShoppingHome.vue?vue&type=template&id=6a32e5f0&scoped=true&lang=pug&"
import script from "./ShoppingHome.vue?vue&type=script&lang=js&"
export * from "./ShoppingHome.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingHome.vue?vue&type=style&index=0&id=6a32e5f0&lang=scss&scoped=true&"
import style1 from "./ShoppingHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32e5f0",
  null
  
)

export default component.exports